import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Job } from './index.types';
import { JobModal } from 'src/scripts/templates/page-career/JobModal';

type Props = {
  name: string;
  jobs: Job[];
};

export const DepartmentItem = ({ name, jobs }: Props) => {
  const [loading, setLoading] = useState(false);
  const [job, setJob] = useState();
  const onClose = () => setJob(undefined);
  const onJobClick = (id: number) => {
    setLoading(true);
    fetch(`https://boards-api.greenhouse.io/v1/boards/aloyoga/jobs/${id}`)
      .then((response) => response.json())
      .then((job) => {
        setLoading(false);
        setJob(job);
      })
      .catch((error) => {
        setLoading(false);
        console.log({ error });
      });
  };
  return (
    <>
      <Grid item sm={12} md={12}>
        <section className="careers-department">
          <h4 className="department-title">{name}</h4>
          <div className="job">
            {jobs.map((job) => (
              <button className="job-link" onClick={() => onJobClick(job.id)}>
                <Grid item className="job-column">
                  <p className="job-title">{job.title}</p>
                </Grid>
                <Grid item className="job-column">
                  <p className="job-location">{job.location.name}</p>
                </Grid>
              </button>
            ))}
          </div>
        </section>
      </Grid>
      {(loading || job) && <JobModal job={job} onClose={onClose} />}
    </>
  );
};
